export default {
  trigger: 'Invitați proprietarul restaurantului',
  title: 'Invitați proprietarul restaurantului',
  description:
    'Creați un cont pentru proprietarul restaurantului. Acesta va primi un e-mail cu o parolă temporară pentru a se conecta și a finaliza configurarea restaurantului.',
  fields: {
    first_name: 'Prenume',
    last_name: 'Nume',
    email: 'E-mail',
  },
  buttons: {
    invite: 'Trimiteți invitația',
    cancel: 'Anulați',
  },
  toasts: {
    invited: '{{email}} a primit invitația de a finaliza configurarea.',
    failed: 'Nu s-a putut crea contul proprietarului. Vă rugăm să încercați din nou.',
  },
};
